import * as $ from 'jquery'

const sizeKitchenMode = () => {
  const screenHeight = $(window).height()
  const topPadding = parseInt($('main.container').css('padding-bottom'))
  const bottomPadding = parseInt($('main.container').css('padding-bottom'))

  const remove = topPadding + bottomPadding + 4
  $('.recipe.kitchen-mode').height(screenHeight - remove)
}

const init = () => {
  $('#enter-kitchen-mode').off('click')
  $('#enter-normal-mode').off('click')

  if (!("wakeLock" in navigator)) {
    console.warn("WakeLock is not supported")
    $('#enter-kitchen-mode').attr('disabled', true)
    return
  }

  let wakeLock = null

  $('#enter-kitchen-mode').click(() => {
    navigator.wakeLock.request("screen").then(wl => {
      wakeLock = wl
      sizeKitchenMode()
      $('.recipe.normal-mode').addClass('hidden')
      $('.recipe.kitchen-mode').removeClass('hidden')
      $('nav').addClass('hidden')
      $('footer').addClass('hidden')
    });
  });

  $('#enter-normal-mode').click(() => {
    if (wakeLock) {
      wakeLock.release().then(() => {
        wakeLock = null
      });
    }

    $('.recipe.kitchen-mode').addClass('hidden')
    $('.recipe.normal-mode').removeClass('hidden')
    $('nav').removeClass('hidden')
    $('footer').removeClass('hidden')
  });
}

$(document).ready(function() {
  init()
})

$(document).on('turbolinks:load', function() {
  init()
})
